// src/config/api.js
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://tailorapi.mentoran.in';

console.log('API Base URL:', API_BASE_URL);
console.log('Environment:', process.env.NODE_ENV);

export const API_ENDPOINTS = {
  // Public endpoints
  PUBLIC: {
    SERVICES: `${API_BASE_URL}/api/public/services`,
    GALLERY: `${API_BASE_URL}/api/public/gallery`,
  },
  // Admin endpoints - REMOVED /admin prefix to match Flask routes
  ADMIN: {
    SERVICES: `${API_BASE_URL}/api/services`,
    GALLERY: `${API_BASE_URL}/api/gallery`,
    CUSTOMERS: `${API_BASE_URL}/api/customers`,
    ORDERS: `${API_BASE_URL}/api/orders`,
    MEASUREMENTS: `${API_BASE_URL}/api/measurements`,
    INVOICES: `${API_BASE_URL}/api/invoice`,
    DASHBOARD_STATS: `${API_BASE_URL}/api/dashboard/stats`,
    REPORTS_SALES: `${API_BASE_URL}/api/reports/sales`,
    // Bulk delete endpoints
    BULK_DELETE_SERVICES: `${API_BASE_URL}/api/services/bulk_delete`,
    BULK_DELETE_GALLERY: `${API_BASE_URL}/api/gallery/bulk_delete`,
  }
};

// Default axios configuration
export const axiosConfig = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export default API_ENDPOINTS;